const COMMENT_SNIPPET_LENGTH = 100

/**
 * Gets a snippet of the comment text, truncated to the maximum length.
 * While `text-overflow: ellipsis` will handle dynamic truncation, we still want to limit the length of the rendered
 * string for accessibility and performance.
 */
export function getCommentSnippet(body: string): string {
  const normalized = body.replace(/\s+/g, ' ').trim()
  const chars = Array.from(normalized)
  return chars.length > COMMENT_SNIPPET_LENGTH ? `${chars.slice(0, COMMENT_SNIPPET_LENGTH).join('')}…` : normalized
}
